import script from "./CreateInformationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateInformationForm.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__